<template>
    <v-container fill-height fluid>
        <v-row align="center" justify="center">
            <v-col>
                <div
                    class="mx-auto"   
                >
                    <v-list-item three-line style="padding:50px">
                        <v-img
                            src="img/logo.png" 
                        ></v-img>    
                    </v-list-item> 
                    <v-list-item three-line :style="heightTop">
                        <v-row>
                                <v-col
                                    cols="12"
                                    sm="12"
                                >
                                    <v-text-field
                                        v-model="login"
                                        label="Email"
                                        outlined
                                        clearable
                                        rounded
                                    ></v-text-field>
                                </v-col>
                        </v-row>
                    </v-list-item>
                    <v-card-actions :style="heightBottom">
                        <v-row>
                            <v-col
                                cols="12"
                                sm="12"
                            >
                                <v-btn
                                    depressed
                                    color="primary"
                                    rounded
                                    block
                                    style="color:white"
                                    @click="next"
                                >
                                    Próximo
                                </v-btn>
                            </v-col>
                            <v-col
                            cols="12"
                            sm="12"
                            align="right" 
                            style="color:#378bac;"
                        >
                                <h6 >by Plataforma SIG</h6>  
                                    </v-col>
                        </v-row>
                    </v-card-actions>
                </div>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog.show"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{dialog.title}}
                </v-card-title>

                <v-card-text>
                    {{dialog.message}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialog.show = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
export default {
    data: () => ({
        heightTop: "margin-top:100px",
        heightBottom: "padding-bottom:50px",
        login: "",
        dialog: {
            show: false,
            title: '',
            message: ''
        }
    }),

    methods: {
        next(){
            if(this.login == ''){
                this.dialog.title = "Dados Inválidos";
                this.dialog.message = "Informe o Login.";
                this.dialog.show = true;
            }
            else
                this.$router.push({name: 'Signature', params: {login: this.login}});
        }
    },

    created(){
        let loginData = JSON.parse(localStorage.getItem("loginData"));
        
        if(loginData != null)
        {
            let canDemands = loginData.permissionAndMenu.find(permission => {
                return permission.menuId == 27
            });

            if(!(canDemands != null || loginData.userData.userType == 2))
                this.$router.push('menu');
            else
                this.$router.push('kpis');
        }
        
        if(this.$route.params.logout){
            this.dialog.title = "Sessão Expirada";
            this.dialog.message = "Sua sessão expirou. Por favor, realize o login novamente.";
            this.dialog.show = true;
        }
    }
}
</script>